import httpService from "../../_services/httpService";

var baseUrl = 'https://readservices-b2c.powerreviews.com';

const powerReviewsService = {
    getReviewsForProduct: function (productId) {
        return httpService({
            url: baseUrl + '/m/' + window.spdc.vendor.prMerchId + '/l/en_US/product/' + productId + '/reviews',
            method: 'GET',
            params: {
                sort: 'HighestRating',
                'paging.size': 25,
                apikey: window.spdc.vendor.prApiKey,
            },
        });
    },
    generateSchema: function(productId) {
        return this.getReviewsForProduct(productId)
            .then(data => ({
                review: data.results[0].reviews.map(review => ({
                    '@type': 'Review',
                    name: review.details.headline,
                    reviewBody: review.details.comments,
                    datePublished: review.details.created_date,
                    author: {
                        '@type': 'Person',
                        name: review.details.nickname,
                    },
                    locationCreated: {
                        '@type': 'AdministrativeArea',
                        name: review.details.location,
                    },
                    reviewRating: {
                        '@type': 'Rating',
                        ratingValue: review.metrics.rating,
                    },
                })),
                aggregateRating: {
                    '@type': 'AggregateRating',
                    ratingValue: data.results[0].rollup.average_rating,
                    reviewCount: data.results[0].rollup.review_count,
                }
            }));
    }
};
export default powerReviewsService;